import { useMutation, MutationHookOptions } from '@apollo/react-hooks';

import { SAVE_ELIGIBLE_MEMBER_FIELD_FOR_APPLICANT_REVIEW } from '../queries/saveEligibleMemberSchemaForApplicantReviewMutation';
import {
  SaveEligibleMemberFieldForApplicantReview,
  SaveEligibleMemberFieldForApplicantReviewVariables,
} from '../queries/types/SaveEligibleMemberFieldForApplicantReview';

type IOptions = MutationHookOptions<
  SaveEligibleMemberFieldForApplicantReview,
  SaveEligibleMemberFieldForApplicantReviewVariables
>;

export const useSaveEligibleMemberFieldForApplicantReview = (options: IOptions = {}) =>
  useMutation<SaveEligibleMemberFieldForApplicantReview, SaveEligibleMemberFieldForApplicantReviewVariables>(
    SAVE_ELIGIBLE_MEMBER_FIELD_FOR_APPLICANT_REVIEW,
    options,
  );
